import { defineMessages } from 'react-intl';

export const messages: {
	dismiss: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	authorize: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	authorizationFail: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	authorizationSuccess: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	connect: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	appFilterTooltipContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	appFilterTooltipContentAlternate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	dismiss: {
		id: 'sidebar-oauth-warning-dismiss',
		defaultMessage: 'Dismiss',
		description: 'Message for button to dismiss the oauth message',
	},
	authorize: {
		id: 'sidebar-oauth-warning-authorize',
		defaultMessage: 'Authorize',
		description: 'Message for button to authorize the third-party product',
	},
	authorizationFail: {
		id: 'sidebar-oauth-warning.authorization-fail',
		defaultMessage: 'Failed to connect to {product}.',
		description: 'Message displayed when authorization fails.',
	},
	authorizationSuccess: {
		id: 'sidebar-oauth-warning.authorization-success',
		defaultMessage: 'Successfully connected to {product}.',
		description: 'Message displayed when authorization is successful.',
	},
	connect: {
		id: 'sidebar-oauth-warning.connect',
		defaultMessage: 'Connect',
		description: 'Message for button to connect the oauth message',
	},
	appFilterTooltipContent: {
		id: 'sidebar-oauth-warning.app-filter-tooltip-content',
		defaultMessage:
			'Connect your account to see missing results, including documents only you have access to.',
		description: 'Message for tooltip content of app filter',
	},
	appFilterTooltipContentAlternate: {
		id: 'sidebar-oauth-warning.app-filter-tooltip-content-alternate',
		defaultMessage:
			'Connect your account to see missing results, including content only you have access to.',
		description: 'Alternate message for tooltip content of app filter',
	},
});
